export default {
  set(state, { data }) {
    state.shelves = data;
  },
  show(state, { data }) {
    state.shelf = data;
  }
}